import { AXLE_PAGE_BACKGROUND_GRAY, AXLE_TEAL } from '@/constants/colors';
import { DefiniteComponent } from '@/utils/reactTypes';
import Route from '@mui/icons-material/Route';
import Settings from '@mui/icons-material/Settings';
import { Box } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router';

export const RouteOptimizerAdminIcon = React.forwardRef<DefiniteComponent>(
    function RouteOptimizerAdminIcon(props, ref) {
        const location = useLocation();
        const isSelected = location.pathname.includes('/route-optimizer/admin');

        return (
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                ref={ref}
                {...props}
            >
                <Route />
                <Settings
                    sx={{
                        fontSize: '1.2rem',
                        backgroundColor: isSelected ? AXLE_TEAL : AXLE_PAGE_BACKGROUND_GRAY,
                        padding: '0.05rem',
                        borderRadius: '50%',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        transform: 'translate(50%, -35%)',
                    }}
                />
            </Box>
        );
    },
);
